class Rotate {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }
  
  bindUI() {
    this.ui = {}
    this.ui.$screen = document.querySelector('.js-screen')
    this.portrait = window.matchMedia("(orientation: portrait)")
  }
  
  bindEvents() {
    this.portrait.addEventListener("change", this.onOrientationChange.bind(this))
  }

  onOrientationChange(e) {
    if(e.matches) {
      document.body.removeAttribute('style')
      this.ui.$screen.style.display = 'none'
    } else {
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.top = 0
      document.body.style.left = 0
      this.ui.$screen.style.display = 'flex'
    }
  }
}

export default Rotate
